import actions from '../../actionTypes';

export default tag => {
  return {
    type: actions.EDITED_TAG,
    tag
  };
};



// WEBPACK FOOTER //
// ./src/reducers/tags/actions/editedTag.js